import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSidebarLeftShow12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconSidebarLeftShow12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M1.5 2H4v8H1.5a.5.5 0 0 1-.5-.5v-7a.5.5 0 0 1 .5-.5m9 0H5v8h5.5a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5m0-1A1.5 1.5 0 0 1 12 2.5v7a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 0 9.5v-7A1.5 1.5 0 0 1 1.5 1zM6.661 4.586a.5.5 0 1 1 .707-.707l1.768 1.767L9.49 6l-.354.354L7.368 8.12a.5.5 0 1 1-.707-.707L8.075 6z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSidebarLeftShow12);
